import React from "react";
import "../../../../../Create_Assessment/Create_Question/Create_Q_Type/createMcq.css";
import "../../../../Published/Published_Q_list/PublishQuestionType/ImgType/imgTypePublishedQuestion.css";
import AttachUInonEditable from "../../../../../Create_Assessment/Create_Question/Create_Q_Type/AttachUInonEditable";
import ZoomableImage from "../../../../../../../Components/zoomablePic";

export default function ImgTypePublishedQuestion(props) {
  return (
    <>
      <div className="d-flex align-items-center justify-content-center">
        <div className="col-11 m-0 mt-3 p-3 question_box_container">
          <div className="d-flex align-items-center">
            {/* Question Number */}
            <div className="hw_question_no me-2">Q{(props.queNo ?? 0) + 1}</div>

            {/* Question Title */}
            <div className="hw_question_box">
              {props.title
                ?.toString()
                .split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {index !== 0 && <br />}
                    <span>{line}</span>
                  </React.Fragment>
                ))}
            </div>

            {/* Attachments */}
            <div style={{ display: "flex", margin: "10px" }}>
              {Array.isArray(props.attachments) &&
                props.attachments.length > 0 &&
                props.attachments.map((attachment, index) => {
                  const ext = attachment?.split(".")?.pop()?.toLowerCase();
                  const isImage = ["jpg", "jpeg", "png"].includes(ext);

                  return (
                    <div
                      key={index}
                      className="mt-2 hw_default_dropdown_container d-flex"
                    >
                      {isImage ? (
                        <ZoomableImage src={attachment} />
                      ) : (
                        <AttachUInonEditable attachments={attachment} />
                      )}
                    </div>
                  );
                })}
            </div>
          </div>

          {/* Meta Info */}
          <div className="mt-2 d-flex align-items-center hw_default_dropdown_container">
            <div className="hw_default_dropdown_card">
              <div className="hw_default_dropdown_box_header">CHAPTER</div>
              <span
                className="hw_default_dropdown_box_size"
                style={{
                  display: "inline-block",
                  maxWidth: "180px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  verticalAlign: "middle",
                  cursor: "pointer",
                  paddingTop: "8px",
                }}
                title={props.chap}
              >
                {props.chap ?? "-"}
              </span>
            </div>

            <div className="gap-3 time_duration_box d-flex justify-content-between">
              <div className="hw_default_dropdown_card2">
                <div className="hw_default_dropdown_box_header">MARKS</div>
                <span className="hw_default_dropdown_box_size">
                  {props.Correct_Score ?? 0} Marks
                </span>
              </div>

              <div className="hw_default_dropdown_card2">
                <div className="hw_default_dropdown_box_header">
                  LEVEL OF DIFFICULTY
                </div>
                <span className="hw_default_dropdown_box_size">
                  {props.difficulty_level ?? "-"}
                </span>
              </div>
            </div>

            <div className="hw_default_dropdown_card">
              <div className="hw_default_dropdown_box_header">SKILLS</div>
              <span className="hw_default_dropdown_box_size">
                {props.skills ?? "-"}
              </span>
            </div>

            <div className="hw_default_dropdown_card">
              <div className="hw_default_dropdown_box_header">
                TYPE OF QUESTION
              </div>
              <span className="hw_default_dropdown_box_size">
                Descriptive Type
              </span>
            </div>
          </div>

          {/* Assessment Checkbox */}
          <div className="mt-2 hw_default_dropdown_container d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-5">
              <div className="hw_mandatory_checkbox">
                <input
                  type="checkbox"
                  checked={props?.addHW === "homework"}
                  readOnly
                />
                &nbsp;
                <span>Add for Assessment</span>
              </div>
            </div>
          </div>

          {/* Correct Answer Section */}
          <div className="mt-3 ml-3 mb-3 col-12">
            <div className="hw_mandatory_checkbox ml-1 mb-2">
              Reason for correct answer
            </div>

            {/* Explanation */}
            {Array.isArray(props.correctAns) && (
              <div style={{ width: "100%", marginTop: "8px" }}>
                {props.correctAns.map((obj, index) => (
                  <div
                    key={index}
                    className="hw_mcq_option_box"
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: "1px solid #d0d7de",
                      backgroundColor: "#f9fafb",
                      fontSize: "14px",
                      lineHeight: "1.6",
                      color: "#333",
                      wordBreak: "break-all", // handles long words
                      overflowWrap: "anywhere", // force break if needed
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {obj.reason_for_answer?.explanation}
                  </div>
                ))}
              </div>
            )}

            {/* Explanation Attachments */}
            {Array.isArray(props.correctAns) &&
              props.correctAns.length > 0 &&
              props.correctAns.map(
                (obj, index) =>
                  obj?.reason_for_answer?.attachment && (
                    <div key={index} style={{ marginTop: "10px" }}>
                      <AttachUInonEditable
                        attachments={obj.reason_for_answer.attachment}
                      />
                    </div>
                  ),
              )}
          </div>
        </div>
      </div>
    </>
  );
}
